export function removeFormatRut(value) {
  return String(value).toUpperCase().replace(/[^0-9Kk]+/g, '');
}

export function formatRut(value) {
  const noFormat = removeFormatRut(value);
  const rut = noFormat.length > 1 ? noFormat.slice(0, -1) : noFormat;
  const dv = noFormat.length > 1 ? noFormat.slice(noFormat.length - 1) : null;
  const result = rut.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return dv == null ? result : `${result}-${dv}`;
}
